var Spinner = require("components/utility/Spinner");

function providePopulateData(ops) {
	ops = ops || {};
	return (WrappedComponent) => {
		class PopulateData extends React.Component {
			constructor(props) {
				super();
				this.state = { requested: false, received: false };
			}

			render() {
				if (!this.state.requested) {
					return <div className="emptyPopulateData" />
				} else if (ops.waitForLoad && !this.state.received) {
					return (
						<div className="emptyPopulateData">
							<Spinner placeholder={ true } scale={ 1.7 } />
						</div>
					);

				} else {
					return React.createElement(WrappedComponent, this.props);
				}
			}

			componentDidMount() {
				if (ops.waitForLoad) {
					// In this case, populateData must return a promise
					this.props.populateData().then(() => {
						this.setState({ received: true })
					})
					this.setState({ requested: true })

				} else {
					this.props.populateData();
					this.setState({ requested: true })
				}
			}
		}
		PopulateData.WrappedComponent = WrappedComponent;

		return PopulateData;
	}
}

module.exports = {
	providePopulateData
}


// WEBPACK FOOTER //
// ./modules/components/utility/hoc/PopulateData.js